<script>
  import { getContext } from 'svelte';
  import { Route, Router } from 'svelte-navigator';

  import Redirect from '@client/app/redirect.svelte';

  import Assign from './assign.svelte';
  import PushHistory from './history/push-history.svelte';
  import Routing from '../routing/routing.svelte';

  const { basepath } = getContext('config');
</script>

<Router>
  <Route path="/">
    <Assign />
  </Route>
  <Route path="history">
    <PushHistory />
  </Route>
  <Route path="routing">
    <Routing />
  </Route>
  <Route path="/*">
    <Redirect path="{basepath}/bizcards/assignment" config={{ replace: true }} />
  </Route>
</Router>
